export class StatePicker
{
    public showOptions: boolean = false;
    public showPanel: boolean = false;
}
